module.exports = __webpack_public_path__ + "img/view-two-pane-inactive.3536561e.svg";